<template>
    <div class="loadBox ac" v-show="showLoad">
        <div class="loadCont">
            <img src="/static/images/loading1.gif"/>
            <p>{{loadHtml}}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "copy",
    props: {
		loadHtml:{
			type:String,
			default:'加载中，请稍后...'
        },
        showLoad:{
            type:Boolean,
            default:false
        }
	},
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods: {
        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/loading.vue